<template>
  <content-loader
    view-box="0 0 420 195"
    :speed="2"
    primary-color="#f3f3f3"
    secondary-color="#ecebeb"
    height="195"
  >
    <rect x="40" y="1" rx="0" ry="0" width="2" height="181" /> 
    <rect x="58" y="58" rx="0" ry="0" width="287" height="3" /> 
    <rect x="58" y="68" rx="0" ry="0" width="287" height="3" /> 
    <rect x="58" y="78" rx="0" ry="0" width="287" height="3" /> 
    <rect x="58" y="88" rx="0" ry="0" width="287" height="3" /> 
    <rect x="58" y="98" rx="0" ry="0" width="287" height="3" /> 
    <rect x="58" y="108" rx="0" ry="0" width="287" height="3" /> 
    <rect x="58" y="118" rx="0" ry="0" width="287" height="3" /> 
    <rect x="58" y="128" rx="0" ry="0" width="287" height="3" /> 
    <rect x="161" y="13" rx="0" ry="0" width="65" height="5" /> 
    <rect x="42" y="1" rx="0" ry="0" width="319" height="2" /> 
    <rect x="361" y="2" rx="0" ry="0" width="2" height="177" /> 
    <rect x="42" y="179" rx="0" ry="0" width="319" height="2" /> 
    <rect x="58" y="48" rx="0" ry="0" width="287" height="3" /> 
    <rect x="58" y="138" rx="0" ry="0" width="287" height="3" /> 
    <rect x="58" y="38" rx="0" ry="0" width="287" height="3" /> 
    <rect x="58" y="28" rx="0" ry="0" width="287" height="3" /> 
    <rect x="58" y="148" rx="0" ry="0" width="287" height="3" /> 
    <rect x="58" y="158" rx="0" ry="0" width="287" height="3" />
  </content-loader>
</template>

<script>
import { ContentLoader } from "vue-content-loader";

export default {
    name: "PdfLoader",
    components: { ContentLoader }
};
</script>